import { render, staticRenderFns } from "./ClassroomFooter.vue?vue&type=template&id=219f92f0&"
import script from "./ClassroomFooter.vue?vue&type=script&lang=js&"
export * from "./ClassroomFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports